export{AnimationDirectionEnum,BarChartComponent,BarGapEnum}from"./bar-chart.component.js";
//# sourceMappingURL=index.js.map
